import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, EditOutlined, DeleteOutlined, MessageOutlined, SendOutlined} from '@ant-design/icons';
import {   ADD_MESSAGE, ADD_MESSAGE_ERROR, ADD_MESSAGE_SUCCESS, DELETE_BATCH, DELETE_BATCH_ERROR, DELETE_BATCH_SUCCESS, EDIT_MESSAGE, EDIT_MESSAGE_ERROR, EDIT_MESSAGE_SUCCESS, MESSAGE_DETAILS, MESSAGE_DETAILS_ERROR, MESSAGE_DETAILS_SUCCESS, MESSAGES_LIST, MESSAGES_LIST_ERROR, MESSAGES_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS} from './constants';
import axios from 'axios';
import CommunicationDataReducer from './reducer';
import { useNavigate } from 'react-router-dom';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useFormik } from 'formik';
import { useAuth } from '../Context';
import TextArea from 'antd/es/input/TextArea';

const { Title } = Typography;



export default function Communication() {
    
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { retrain_historydata:[], batch : [], details: null, loading: false, error: false, modelDeploymentInfo:[]};
	const [data, dispatch] = useReducer(CommunicationDataReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteMessageModal, setShowDeleteMessageModal] = useState(false);
	const userid = localStorage.getItem(`${dashboardtype.toUpperCase()}_USER_ID`);
	useAuth();
	

	
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	
	

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const {getRegion, regiondata } = useAuth();
	const [modalRegionId , setModalRegion] = useState(null);
	
	const actionEnable = false;

	const columns = [

		
		{
			title: `${langdata && langdata.Message ? langdata.Message:'Message'}`,
			dataIndex: 'text',
			key: 'text',
			
		},
		{
			title: `${langdata && langdata.Users ? langdata.Users:'Users'}`,
			dataIndex: 'toUserNames',
			key: 'toUserNames',
			
		},
		{
			title: `${langdata && langdata.Region ? langdata.Region:'Region'}`,
			dataIndex: 'regionName',
			key: 'regionName',
			
		},
	];

	if(actionEnable){
		columns.push({
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: () => (
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></a>
					</Space>
				</>
			)
		});
	}

	

	
	useEffect(() => {
		if(featuresModule.communicationEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
		getRegion(authtoken);
	
	},[authtoken,modalRegionId]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4022);

	}, []);
	
	useEffect(() => {
		loadMessages();
		usersList();
	}, []);


	const loadMessages = () => {
		let params = '';
		if(admin_roles.includes(permission)){
			params = '';
		}
		else{
			params = `&fromuserId=${userid}`;
		}

		dispatch({ type : MESSAGES_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/communication?pipelineId=${pipelineId}${params}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
    
		axios.request(config)
			.then((response) => {

				if (response.status === 200) {
					dispatch({ type : MESSAGES_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : MESSAGES_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : MESSAGES_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	
	
	



	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.ThisModuleIsdesignedForAdministratorsToSendAlertNotificationsToSelectedUsersUsersWillReceiveCorrespondingNotificationMessages ? langdata.ThisModuleIsdesignedForAdministratorsToSendAlertNotificationsToSelectedUsersUsersWillReceiveCorrespondingNotificationMessages :'This module is designed for administrators to send alert notifications to selected users. Users will receive corresponding notification messages.'}</p>
		</Card>
	);


	const showAddDrawer = () => {

		setOpenAddDrawer(true);
	};

	const onCloseAddDrawer = () => {
		setOpenAddDrawer(false);
		form.resetFields();
	};

	const showEditDrawer = () => {
		
		setOpenEditDrawer(true);
		
	};

	const openDeleteAssetsModal = () => {
		setShowDeleteMessageModal(true);
	};

	const sendMessage = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
			touserIds : null,


	
		},
		onSubmit: (values) => {
	
					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheMessage ? langdata.PleaseEnterTheMessage : 'Please enter the message.' });
				return false;
			}
	
			dispatch({type:ADD_MESSAGE});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/communication`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					text : values.name,
					touserIds : values.touserIds,
					fromuserId : parseInt(userid),
					pipelineId : parseInt(pipelineId),
					regioninfoId : values.regioninfoId
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_MESSAGE_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.SentMessageSuccessfully ? langdata.SentMessageSuccessfully :'Sent message successfully'}` });
						loadMessages();
						form.resetFields();
						sendMessage.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: ADD_MESSAGE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const editMessage = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.text || '',
			touserIds : data?.details?.toUsers,
			regioninfoId : data?.details?.regioninfoId

			
		},
		onSubmit: (values) => {
	
		
			dispatch({type:EDIT_MESSAGE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/communication/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					text : values.name,
					touserIds : values.touserIds,
					fromuserId : parseInt(userid),
					pipelineId : parseInt(pipelineId),
					regioninfoId : values.regioninfoId
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_MESSAGE_SUCCESS});
						Modal.success({ title: `${langdata && langdata.MessageUpdatedSuccessfully ? langdata.MessageUpdatedSuccessfully :'Message updated successfully'}` });
						editMessage.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadMessages();
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_MESSAGE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadMessageDetails = ((record) => {
		
		dispatch( { type: MESSAGE_DETAILS });
			
		if (!record) {
			dispatch({ type: MESSAGE_DETAILS_ERROR });
		} else {
			dispatch({ type: MESSAGE_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		setOpenEditDrawer(false);

	};
	const closeDeleteBatchModal = () => {
		setShowDeleteMessageModal(false);
	};

	const deleteMessage = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_BATCH });
		
		let config = {
			method: 'delete',   
			maxBodyLength: Infinity,
			url: `${api}/communication/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_BATCH_SUCCESS, payload: response});
					setShowDeleteMessageModal(false);        
					loadMessages();
				} else {
					dispatch({type:DELETE_BATCH_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_BATCH_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let users=[{value : 'alllinewalkers', label : 'ALL LINEWALKERS'}, {value : 'allnpv', label : 'ALL NPV'}, {value : 'allqrt', label : 'ALL QRT'}];
	
	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const usersList = () => {
    
		dispatch({ type : USERS_LIST});
    
		// const usertypeparams = usertypeId && usertypeId == 'All' ? '&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13' : usertypeId=='Linewalker' ? 'usertypeId=4' : usertypeId=='NPV' ? 'usertypeId=7' : usertypeId=='QRT' ? 'usertypeId=13' : '';
    
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?&isDeleted=false&usertypeId[$ne]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
          
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	let modalRegion = [];

	
		
	regiondata && regiondata.map((region)=>{
		modalRegion.push({
			value:region.id,
			label:region.regionName.toUpperCase()});
	}); 
	

	const handleRegion = (value) => {
		setModalRegion(value);
		
		
	};

	const handleAddFormValuesChange = (changedValues)=>{
		
		const regionVal = Object.keys(changedValues)[0];

		if(regionVal==='regioninfoId'){
			sendMessage.setFieldValue('regioninfoId', changedValues.regioninfoId);

		}
		
		
	};

	const handleUpdateFormValuesChange = (changedValues)=>{
		
		const regionVal = Object.keys(changedValues)[0];
		
		
		if(regionVal==='regioninfoId'){
			
			
			editMessage.setFieldValue('regioninfoId', changedValues.regioninfoId);
			

		}
		
	};


	return (
		<>
			<Content>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<MessageOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Communication ? langdata.Communication:'Communication'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><SendOutlined />{langdata && langdata.SendMessage ? langdata.SendMessage : 'Send Message'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.Communication ? langdata.Communication:'Communication'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.batch?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.batch} 
								onChange = { loadMessages }
								
								
								onRow={(record) => {
									return {
										onClick: () => { 
											loadMessageDetails(record);
										}
									};
								}} />
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.SendMessage ? langdata.SendMessage : 'Send Message' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							<Button type="primary" onClick={sendMessage.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button>
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={sendMessage.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Message?langdata.Message:'Message'} rules={[{ required: true, message: langdata && langdata.PleaseEnterMessage ? langdata.PleaseEnterMessage : 'Please enter message' }]} >
									<TextArea autoSize={{ minRows: 3}} name="name" onChange={sendMessage.handleChange} placeholder={langdata&&langdata.PleaseEnterMessage?langdata.PleaseEnterMessage:'Please enter message'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.SelectUsers ? langdata.SelectUsers : 'Select Users'} name="tousers" rules={[{ required: true , message : langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users' }]}>
									<Select Item
										name="tousers"
										mode="multiple"
										showSearch
										placeholder={langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users'}
										optionFilterProp="children"
										filterOption={filterOption}
										options={users}
										onChange={(value) => sendMessage.setFieldValue('touserIds', value)}
									/>
								</Form.Item>
							</Col>
						</Row>		
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item
									label={langdata && langdata.Region ? langdata.Region : 'Region'}
									name="regioninfoId"
									rules={[{ required: true }]}>
						
									<Select
										name="regioninfoId"
										style={{ minWidth: '100%'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Region ? langdata.Region : 'Region'}
										optionFilterProp="children"
										options={modalRegion}
										onChange={handleRegion}
															
										onSelect={(value)=>{handleAddFormValuesChange({'regioninfoId': value});}}
						
															
							
									/>
						
								</Form.Item>
							</Col>
						</Row>									
					</Form>
				</Modal>


				<Modal
					title={langdata && langdata.EditMessage ? langdata.EditMessage:'Edit Message'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editMessage.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editMessage.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editMessage.handleSubmit} layout="vertical"
						form={form} 
						// onValuesChange={handleUpdateFormValuesChange}
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<TextArea autoSize={{ minRows: 3}} name="name" value={editMessage.values.name} onChange={editMessage.handleChange} defaultValue={editMessage.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.SelectUsers ? langdata.SelectUsers : 'Select Users'} name="tousers" rules={[{ required: true , message : langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users' }]}>
									<Select Item
										name="tousers"
										mode="multiple"
										showSearch
										placeholder={langdata && langdata.PleaseSelectUsers ? langdata.PleaseSelectUsers : 'Please select users'}
										defaultValue={editMessage.values.touserIds}
										optionFilterProp="children"
										filterOption={filterOption}
										options={users}
										onChange={(value) => editMessage.setFieldValue('touserIds', value)}
									/>
								</Form.Item>
							</Col>
						</Row>	

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item
									label={langdata && langdata.Region ? langdata.Region : 'Region'}
									// name="regioninfoId"
									rules={[{ required: false }]}>
						
									<Select
						
										name="regioninfoId"
										// filterOption={filterOption}
										placeholder={langdata && langdata.Region ? langdata.Region : 'Region'}
						
										options={modalRegion}
										onSelect={(value)=>{handleUpdateFormValuesChange({'regioninfoId': value});}}
										defaultValue={editMessage.values.regioninfoId}
										onChange={handleRegion}
															
						
						
									/>
						
								</Form.Item>
							</Col>
						</Row>

						
				
									
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteMessageModal} onOk={deleteMessage} onCancel={closeDeleteBatchModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisMessage ? langdata.AreYouSureYouWantToDeleteThisMessage : 'Are you sure you want to delete this message.' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}